import { Component, OnInit } from '@angular/core';
import {DashboardService} from '../../../modules/service/dashboard.service';
import {Router} from '@angular/router';
import Swal from 'sweetalert2';
import {StickerService} from '../../../modules/service/stickerservice.service';
import { MatSelectChange } from '@angular/material';
import {Chart} from 'chart.js'

interface DurationPeriod {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-widget-stickersalesgraph',
  templateUrl: './stickersalesgraph.component.html',
  styleUrls: ['./stickersalesgraph.component.scss']
})
export class StickersalesgraphComponent implements OnInit {


  chart: Chart;
  selected = '30';

  selectedValue: string;

  days: DurationPeriod[] = [
    {value: '7', viewValue: 'Last 7 Days'},
    {value: '30', viewValue: 'Last 30 Days'},
    {value: 'months', viewValue: 'Last Year'}
  ];
 

  ud = JSON.parse(localStorage.getItem('userdata')); //get users email


  total:any;
  transact:any;
  pending:any;

  loaderror:any=''

sday:boolean=true;
thday:boolean=false;
yrday:boolean=false;

  loading:boolean = false;
  topperformstartdate:any;
  topperformenddate:any;
  selectmonth: any;

  periodchart:any=[];
  

  constructor(public service: DashboardService, public router:Router,  public stickerservice: StickerService) { }

  ngOnInit() {

    var today = new Date(); //get todays date
this.topperformenddate = today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date

today.setDate(today.getDate() - 30) // subtract 7 days from todays date
this.topperformstartdate = today.toISOString().substring(0,10) //set that date to start date

this.perfomanceDetails()

  }


  perfomanceDetails(){

    let minDate = new Date(this.topperformstartdate)
    let maxDate = new Date(this.topperformenddate)
    var days ;


    
    days = (maxDate.getTime()-minDate.getTime())/(1000 * 3600 * 24)
  // console.log("days" + days);
  


  if (days > 30 ){

    days = "months";
  }

  if(this.chart!=null){

    this.chart.destroy();
}

    // if (days === 7 || days === 30 ) {
      if (this.topperformstartdate === undefined || this.topperformenddate === undefined) {
        (Swal as any).fire({ icon: 'error',title: 'Oops...',text: 'Start Date or End Date was not selected.',footer: 'Please, make the necessary changes and try again.'});
      } else if(this.topperformstartdate > this.topperformenddate) { 
        (Swal as any).fire({ icon: 'error',title: 'Oops...',text: 'Start Date is more than End Date.',footer: 'Please, make the necessary changes and try again.'});
      } else {
        this.loading = true;


       // console.log("mindate" + this.topperformstartdate)
       // console.log("max" + this.topperformenddate)
        this.service.getStickersalesgraph({email:this.ud.email,minDate:this.topperformstartdate,maxDate:this.topperformenddate,duration:days.toString(), role:this.ud.role})
          .subscribe(data => {
            this.loading = false;
            this.periodchart = data['responseData'];


        
             console.log("chart" + this.periodchart)
            let labels = [],counts=[];
            data['responseData'].forEach(element => {
              labels.push(element.DATES);
              counts.push(element.TOTAL);
              // amounts.push(parseFloat(element.total.replace(/,/g,'')));
            });

            
          
            this.chart = this.stickerservice.getStickerChart(labels,counts,'stickersalesgraph');
    
            // this.topperformenddate = ''
            // this.topperformstartdate = ''
    
          },error => {
            this.loading = false;
            (Swal as any).fire({ icon: 'error',title: 'Oops...',text: error.message,footer: 'Please, make the necessary changes and try again.'});
          })
      }
    //} 
    // else {
    //   return  (Swal as any).fire({ icon: 'error',title: 'Oops...',text: 'Interval Should be 7 or 30 days',footer: 'Please, make the necessary changes and try again.'});
    // }
    
    
  }



  changeRatio(event: MatSelectChange) {
    console.log(event.value);

if (event.value == "7"){
  console.log("doing 7");
  this.day_7()
  
}
else if (event.value == "30"){

  console.log("doing 30");
  this.day_30()

}
else {

  console.log("doing 365");
  this.day_365()
}


  }


  day_7(){
    this.sday = true;
    this.thday = false;
    this.yrday = false;

    var today = new Date(); //get todays date
    this.topperformenddate = today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date
    
    today.setDate(today.getDate() - 7) // subtract 7 days from todays date
    this.topperformstartdate = today.toISOString().substring(0,10) //set that date to start date
    
    this.perfomanceDetails()
  }

  day_30(){
    this.sday = false;
    this.thday = true;
    this.yrday = false;
    var today = new Date(); //get todays date
    this.topperformenddate = today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date  
    today.setDate(today.getDate() - 30) // subtract 7 days from todays date
    this.topperformstartdate = today.toISOString().substring(0,10) //set that date to start date
    
    this.perfomanceDetails()
  }

  day_365(){
    this.sday = false;
    this.thday = false;
    this.yrday = true;
    var today = new Date(); //get todays date
    this.topperformenddate = today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date
    
    today.setDate(today.getDate() - 365) // subtract 7 days from todays date
    this.topperformstartdate = today.toISOString().substring(0,10) //set that date to start date    
    this.perfomanceDetails()
  }



}
